import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import aboutImage from '../../assets/ab/Slide4.jpg';
import abutImage from '../../assets/ab/Slide6.jpg';
import boutImage from '../../assets/ab/Slide7.jpg';
import otImage from '../../assets/ww.jpg';
import atImage from '../../assets/ab/Slide8.jpg';
import aoImage from '../../assets/az/Slide1.jpg';
import aotmage from '../../assets/ab/Slide2.jpg';
import aotIage from '../../assets/ab/Slide3.jpg';
import aotIag from '../../assets/qq.jpg';
import aotIae from '../../assets/ab/Slide9.jpg';

import './ImageSlid.css';

const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  responsive: [
    {
      breakpoint: 768, // This means at a viewport width of 768px and below
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can add more breakpoints here if needed
  ]
}



const ImageSlid = () => {
 
  return (
    <Slider {...settings}>
    
     
      <div>
        <img src={aboutImage} alt="About page image 1" />
      </div>
   
      <div>
        <img src={abutImage} alt="About page image 2" />
      </div>
      <div>
        <img src={boutImage} alt="About page image 3" />
      </div>   
      <div>
        <img src={aotIage} alt="About page image 3" />
      </div>
     
      <div>
        <img src={aotmage} alt="About page image 3" />
      </div>
      

      <div>
        <img src={aoImage} alt="About page image 3" />
      </div>
      <div>
        <img src={atImage} alt="About page image 3" />
      </div>
      {/* <div>
        <img src={otImage} alt="About page image 3" />
      </div> */}
      {/* <div>
        <img src={aotIe} alt="About page image 3" />
      </div> */}
      <div>
        <img src={aotIae} alt="About page image 3" />
      </div>
    </Slider>
  );
};

export default ImageSlid;
